import { Box } from "@mui/material"
import GerudoCardItem from "../inventory/items/GerudoCardItem"
import RutoLetterItem from "../inventory/items/RutoLetterBottle"
import AdultSequenceItem from "../inventory/items/AdultSequenceItem"
import { SimpleGoldenSkultulaItem } from "../inventory/items/TokenCounterItem"
import { SimpleHylianShieldItem } from "../inventory/items/HylianShieldItem"
import { SimpleDekuShieldItem } from "../inventory/items/DekuShieldItem"

interface AdditionalItemTrackerProps {
    gerudoCardShuffle: boolean,
    openFountain: boolean,
    adultTradeSequenceOnlyOne: boolean,
    top?: number,
    left?: number

}

const AdditionalItemTracker = (props: AdditionalItemTrackerProps) => {


    return <Box display={"flex"}>
        {props.gerudoCardShuffle && <GerudoCardItem />}
        {!props.openFountain && <RutoLetterItem />}
        {props.adultTradeSequenceOnlyOne && <AdultSequenceItem type="all"/>}
        <SimpleGoldenSkultulaItem />
        <SimpleHylianShieldItem />
        <SimpleDekuShieldItem />
    </Box>
}

export default AdditionalItemTracker